import { render, staticRenderFns } from "./FooterInfo.vue?vue&type=template&id=e3950528&scoped=true&"
import script from "./FooterInfo.vue?vue&type=script&lang=js&"
export * from "./FooterInfo.vue?vue&type=script&lang=js&"
import style0 from "./FooterInfo.vue?vue&type=style&index=0&id=e3950528&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3950528",
  null
  
)

export default component.exports